import ProductionMonitorStore from "./ProductionMonitor/ProductionMonitor.Store";
import HoldManagementStore from "./HoldManagement/HoldManagement.Store";
import BatchPlantDashboardViewStore from "./Dashboard/BatchPlantDashboardViewStore";
import BatchPlantVisualizerViewStore from "./BatchPlantVisualizer/BatchPlantVisualizerViewStore";

const batchPlantStoreList = [
    { name: "batchPlantDashboardViewStore", store: BatchPlantDashboardViewStore },
    { name: "batchPlantVisualizerViewStore", store: BatchPlantVisualizerViewStore },
    { name: "productionMonitorStore", store: ProductionMonitorStore },
    { name: "holdManagementStore", store: HoldManagementStore },
];

// Removed precast-specific stores:
// - FabricationSequenceStore - Panel fabrication sequences
// - CastingMapStore - Casting bed/table layouts
// - MoldEngineerAssignmentStore - Mold and engineer assignments
// - ManholeViewStore - Manhole production tracking
// - TrailerLoadViewStore - Trailer loading for panel delivery

export default batchPlantStoreList;
